import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

import Radio from '@mui/material/Radio';

import FormControlLabel from '@mui/material/FormControlLabel';


import { v4 as uuid } from 'uuid';
import { removeItemWithSlice, noWheelInputProps } from 'util/utils'



const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 275,
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    buttonLowCase: {
        textTransform: "none"
    }
}));

const NewSizes = (props) => {
    const classes = useStyles();


    const [sizes, setSizes] = useState([]);


    useEffect(() => {

        setSizes(props.sizeList);

        // Only re-seed when the list itself changes; `[props]` re-ran on every
        // parent render and wiped half-typed size prices.
    }, [props.sizeList]);

    const updateSizes = (newSizes, needUpdateParent) => {
        const theNewSizes = newSizes.map((item, index) => ({...item, sort: index}));
        setSizes(theNewSizes);
        if (needUpdateParent) {
            props.updateSizes(theNewSizes)
        }
    };


    const addNewSize = () => {
        let newSizes = [...sizes];
        newSizes.push({ id: uuid(), name: '', default: false, groups: [] });
        console.log('newSizes', newSizes);
        updateSizes(newSizes, false);
    };

    const updateName = (value, id) => {
        let newSizes = [...sizes];
        const index = newSizes.findIndex(size => size.id === id);
        if (index !== -1) {
            let size = newSizes[index];
            newSizes[index] = { ...size, name: value };
            updateSizes(newSizes, true);
        }
    };

    const updatePrice = (value, id) => {
        let newSizes = [...sizes];
        const index = newSizes.findIndex(size => size.id === id);
        if (index !== -1) {
            let size = newSizes[index];

            newSizes[index] = { ...size, price: value };
            updateSizes(newSizes, true);
        }
    };

    const deleteSize = (id) => {
        const index = sizes.findIndex(size => size.id === id);
        if (index !== -1) {
            const newSizes = removeItemWithSlice(sizes, index);
            updateSizes(newSizes, true);
        }
    };

    const updateSelected = (id, value) => {
        let newSizes = [...sizes];
        const index = newSizes.findIndex(size => size.id === id);
        if (index !== -1) {
            let size = newSizes[index];
            newSizes[index] = { ...size, default: !size.default };
            updateSizes(newSizes, true);
        }
    };


    return (

        <Grid container direction="column" spacing={2} >


            {sizes && sizes.length > 0 ? <>
                {sizes.map((size) => {
                    return <Grid item container direction="row" spacing={1} key={size.id} alignItems="center">
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Size Name"
                                margin="dense"
                                name="name"
                                variant="outlined"
                                value={size.name}
                                onChange={e => updateName(e.target.value, size.id)}
                            />
                        </Grid>



                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Size Price"
                                margin="dense"
                                name="price"
                                variant="outlined"
                                type="number"
                                inputProps={noWheelInputProps}
                                value={size.price}
                                onChange={e => updatePrice(e.target.value, size.id)}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <IconButton aria-label="more" className={classes.margin} edge='end' color="secondary" onClick={e => deleteSize(size.id)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Grid>
                        {/* <Button className={classes.buttonLowCase} variant="outlined" color="primary" size="small" onClick={e => deleteSize(size.id)}>Delete</Button> */}
                        <Grid item xs={2}>
                            <FormControlLabel control={<Radio color="primary" value={size.default} checked={size.default} onClick={e => updateSelected(size.id, e.target.value)} />} label="Selected" />
                        </Grid>


                    </Grid>
                })}
                <Grid item xs={4}>
                    <Button className={classes.buttonLowCase} variant="outlined" color="primary" size="small" onClick={addNewSize}>Add size</Button>
                </Grid>
            </> :
                <Grid item xs={4}>
                    <Button className={classes.buttonLowCase} variant="outlined" color="primary" onClick={addNewSize} size="medium">Multiple Sizes</Button>
                </Grid>
            }

        </Grid>

    );
};

export default NewSizes;
